module.exports = __webpack_public_path__ + "static/media/SMLogo.4c1c1ba9.png";